// constants.js
import constants from './constants.json';

export const COURSE_DETAIL_URL = constants.COURSE_DETAIL_URL;
export const PROVIDER_ID = constants.PROVIDER_ID;